import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20dbccc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDESideBarContentTabFileSystemTree" }
const _hoisted_2 = { key: 0 }

import { ref, withDefaults, watch } from 'vue';

export interface PropsOptions {
	filesTree: IDESideBarContentTabFileSystem.FilesTree|null,
	level: number,
}


import * as IDESideBarContentTabFileSystem from './IDESideBarContentTabFileSystem.vue';
import * as IDESideBarContentTabFileSystemTreeEntry from './IDESideBarContentTabFileSystemTreeEntry.vue';


export const EmitsOptions = {
	'onClickFile' : (fileEntry: IDESideBarContentTabFileSystem.FSEntryFile) => {return true;},
	'onClickDirectory' : (directoryEntry: IDESideBarContentTabFileSystem.FSEntryDirectory) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentTabFileSystemTree',
  props: {
    filesTree: { default() {
		return null;
	} },
    level: { default() {
		return 0;
	} }
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { filesTree: IDESideBarContentTabFileSystem.FilesTree|null, level: number }






return (_ctx: any,_cache: any) => {
  const _component_IDESideBarContentTabFileSystemTree = _resolveComponent("IDESideBarContentTabFileSystemTree", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.filesTree)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filesTree.directories, (directory) => {
            return (_openBlock(), _createElementBlock("div", {
              key: directory.filename
            }, [
              _createVNode(IDESideBarContentTabFileSystemTreeEntry.default, {
                entry: directory,
                level: __props.level,
                onOnClickDirectory: _cache[0] || (_cache[0] = (...args) => emit('onClickDirectory', ...args))
              }, null, 8, ["entry", "level"]),
              (directory.expanded)
                ? (_openBlock(), _createBlock(_component_IDESideBarContentTabFileSystemTree, {
                    key: 0,
                    filesTree: directory.subtree,
                    level: __props.level + 1,
                    onOnClickDirectory: _cache[1] || (_cache[1] = (...args) => emit('onClickDirectory', ...args)),
                    onOnClickFile: _cache[2] || (_cache[2] = (...args) => emit('onClickFile', ...args))
                  }, null, 8, ["filesTree", "level"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filesTree.files, (file) => {
            return (_openBlock(), _createBlock(IDESideBarContentTabFileSystemTreeEntry.default, {
              key: file.filename,
              entry: file,
              level: __props.level,
              onOnClickFile: _cache[3] || (_cache[3] = (...args) => emit('onClickFile', ...args))
            }, null, 8, ["entry", "level"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})